import spartaGlobalFunctions from '@sparta.global.utilities/sparta-global-functions-utility/dist/es6.js';
import spartaEventsUtility from '@sparta.global.utilities/sparta-events-utility/dist/es6.js';
import ShieldTransport from '@sparta.sales.utilities/shield-transport-utility/dist/es6.js';

/* global alloy */

/**
 * @param {Object} container container to change
 * @param {String} content content to insert
 * @param {String} method content to insert
 * @return {void}
 */
function insertContent(container, content, method) {
  // eslint-disable-next-line no-param-reassign
  container[method] = content;
}

/**
 * Fetch content from adobe
 * @param {String} containerId mbox id
 * @returns {Promise} adobe content id and coids
 */
async function getAdobeContent(containerId) {
  let jsonEl;
  let clickTrackId;
  let parsedElContent;
  let proposition;
  const propositions = [];
  const adobeContent = new Promise(resolve => {
    alloy('sendEvent', {
      decisionScopes: [containerId],
      xdm: {
        eventType: 'regionalmbox.request'
      }
    }).then(result => {
      if (result.propositions && result.propositions.length > 0) {
        const {
          decisions
        } = result;

        // Filter for decision related to containerId
        const filteredDecisions = decisions.filter(decision => decision.scope === containerId);
        const filteredItem = filteredDecisions[0].items.filter(item => item.schema === 'https://ns.adobe.com/personalization/html-content-item');

        // secondary check for schema in case propositions are empty
        if (filteredItem.length > 0) {
          const {
            content
          } = filteredItem[0].data;
          const scope = containerId;
          if (content) {
            const targetedContainer = document.getElementById(`mbox-${containerId}`);
            insertContent(targetedContainer, content, 'innerHTML');
            jsonEl = targetedContainer.querySelector('[type="application/json"]');
            parsedElContent = JSON.parse(jsonEl.textContent);
            proposition = {
              id: filteredDecisions[0].id,
              scope,
              scopeDetails: filteredDecisions[0].scopeDetails
            };
          }
          propositions.push(proposition);
          clickTrackId = filteredDecisions[0].items[0].meta['activity.id'];

          // event needed because ad container is deleted then recreated
          spartaEventsUtility.sub(`target-${containerId}`, () => {
            const container = document.querySelector(`[data-ad-container='${containerId}']`);
            // if container exists, set adobe click event tracking
            if (container) {
              container.addEventListener('click', () => {
                alloy('sendEvent', {
                  xdm: {
                    // eventType denotes that a click was recorded
                    eventType: 'decisioning.propositionInteract',
                    _experience: {
                      decisioning: {
                        propositions: [proposition]
                      }
                    }
                  }
                });
              });
            }
          });
        }
        resolve({
          ...parsedElContent,
          ...{
            clickTrackId
          }
        });
        alloy('sendEvent', {
          xdm: {
            // eventType denotes that targeted content was displayed
            eventType: 'decisioning.propositionDisplay',
            _experience: {
              decisioning: {
                propositions,
                propositionEventType: {
                  display: 1
                }
              }
            }
          }
        });
      }
    });
  });
  return adobeContent;
}

/**
 * @param {String} [contentKey='default'] name of jcr content
 * @returns {Promise} shield data
 */
async function getShieldContent(contentKey) {
  return new Promise((resolve, reject) => {
    const transport = new ShieldTransport();
    transport.get(contentKey).then(data => resolve(data)).catch(e => {
      reject(e);
    });
  });
}

/**
 * get ad container content
 * @param {Node} containerEl ad container node
 * @param {Boolean} mockShieldResponse use the mock shield response
 * @returns {undefined}
 */
async function getAdContainerContent(containerEl, mockShieldResponse) {
  let clickToken;
  let containerId;
  let contentKey;
  let contentResponse;
  let adobeJsonObj;
  let shieldJcr;
  let contentRendered = false;

  // Extract container id
  if (containerEl.dataset && containerEl.dataset.adContainer) {
    containerId = containerEl.dataset.adContainer;
    contentKey = containerEl.dataset.defaultContentKey;
  }
  if (containerId) {
    try {
      // For targeted content preview page
      const previewContentKey = spartaGlobalFunctions.getUrlParam('contentKey');
      const previewContainerId = spartaGlobalFunctions.getUrlParam('containerId');
      const isPreview = !!(previewContentKey && previewContainerId);
      contentKey = previewContentKey || contentKey;
      containerId = previewContainerId || containerId;
      if (previewContainerId && previewContentKey) {
        shieldJcr = await getShieldContent(contentKey);
        if (shieldJcr && shieldJcr.length > 0) {
          [contentResponse] = shieldJcr;
          if (clickToken) {
            contentResponse.clickToken = clickToken;
          }
        }
        spartaEventsUtility.pub(`target-${containerId}`, {
          contentResponse,
          adobeJsonObj
        });
      } else {
        await document.addEventListener('alloyReady', () => {
          // Call Shield for content
          if (!mockShieldResponse) {
            // Call Adobe for content ids
            if (!isPreview) {
              getAdobeContent(containerId).then(result => {
                adobeJsonObj = result;
                // if adobe content retrieved and content not yet rendered
                if (adobeJsonObj && !contentRendered) {
                  // get the info from the above
                  if (adobeJsonObj.contentKey) {
                    contentKey = adobeJsonObj.contentKey || contentKey;
                    clickToken = adobeJsonObj.clickTrackId;
                  }

                  // if adobe content pulled, remove default container to prevent click confusion
                  const mastheadDefaultContainer = document.getElementById('masthead-default');
                  mastheadDefaultContainer.remove();
                }
                getShieldContent(contentKey).then(shieldResult => {
                  if (shieldResult && shieldResult.length > 0) {
                    [contentResponse] = shieldResult;
                    if (clickToken) {
                      contentResponse.clickToken = clickToken;
                    }
                  }
                });
              });
            }
          }
        });
        setTimeout(() => {
          spartaEventsUtility.pub(`target-${containerId}`, {
            contentResponse,
            adobeJsonObj
          });
          contentRendered = true;
        }, 3000);
      }
    } catch (error) {
      console.error(error);
    }
  } else {
    console.warn('Missing ad container id');
  }
}

export { getAdContainerContent as default };
